<script setup lang="ts">
import { computed } from 'vue'
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'

const props = defineProps<{
  url: string
  bgImageUrl: string
  locked?: boolean
}>()

const backgroundImageUrl = computed(() => urlFromAWSUrl(props.bgImageUrl, [{ width: 200, q: 80 }]))
</script>

<template>
  <component
    :is="locked ? 'span' : 'a'"
    class="group relative my-2.5 block h-[150px]"
    :class="locked ? 'cursor-not-allowed' : 'focus-visible:outline-offset-1'"
    :href="locked ? undefined : url"
    :target="locked ? undefined : '_blank'"
    :rel="locked ? undefined : 'noopener'"
  >
    <span class="absolute inset-0 bg-cover bg-center" :style="{ backgroundImage: `url('${backgroundImageUrl}')` }" />
    <span class="absolute inset-0 block bg-black/70" :class="{ 'group-hover:hidden group-focus-within:hidden': !locked }">
      <slot name="defaultContent" />
    </span>
    <span
      v-if="!locked"
      class="absolute inset-0 hidden bg-black/80 group-hover:block group-focus-within:block"
    >
      <slot name="hoverContent" />
    </span>
    <span v-if="!locked" class="sr-only">(opens in a new tab)</span>
  </component>
</template>
